export default __webpack_public_path__ + "static/media/diploma.a555f01d.svg";